(() => {
  let emailChooserTrigger = null;

  const getFocusableElements = (modal) => Array.from(
    modal.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
  ).filter((element) => !element.hidden);

  const closeEmailChooser = (modal) => {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('seal-email-chooser-open');
    if (emailChooserTrigger) emailChooserTrigger.focus();
    emailChooserTrigger = null;
  };

  const openEmailChooser = (button) => {
    const section = button.closest('.seal-email-support');
    const modal = section && section.querySelector('[data-seal-email-chooser]');
    if (!modal) return;

    emailChooserTrigger = button;
    modal.hidden = false;
    document.body.classList.add('seal-email-chooser-open');
    const focusable = getFocusableElements(modal);
    if (focusable.length) focusable[0].focus();
  };

  const copyWithFallback = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();

    const copied = document.execCommand('copy');
    input.remove();

    if (!copied) {
      throw new Error('Copy command was not accepted.');
    }
  };

  document.addEventListener('click', async (event) => {
    if (event.target.matches('[data-seal-email-chooser]')) {
      closeEmailChooser(event.target);
      return;
    }

    const chooserButton = event.target.closest('[data-seal-email-chooser-open]');
    if (chooserButton) {
      openEmailChooser(chooserButton);
      return;
    }

    const closeButton = event.target.closest('[data-seal-email-chooser-close]');
    if (closeButton) {
      closeEmailChooser(closeButton.closest('[data-seal-email-chooser]'));
      return;
    }

    const button = event.target.closest('[data-seal-copy-email]');
    if (!button) return;

    const section = button.closest('.seal-email-support');
    const feedback = section && section.querySelector('[data-seal-copy-feedback]');

    try {
      await copyWithFallback(button.dataset.email);
      if (feedback) feedback.textContent = 'Email address copied.';
    } catch (error) {
      if (feedback) feedback.textContent = 'Copy failed. Please copy the email address shown above.';
    }

    window.clearTimeout(button.copyFeedbackTimer);
    button.copyFeedbackTimer = window.setTimeout(() => {
      if (feedback) feedback.textContent = '';
    }, 3000);
  });

  document.addEventListener('keydown', (event) => {
    const modal = document.querySelector('[data-seal-email-chooser]:not([hidden])');
    if (!modal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeEmailChooser(modal);
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = getFocusableElements(modal);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
